import { render, staticRenderFns } from "./ArtifactItem.vue?vue&type=template&id=e34fbd70&scoped=true&"
import script from "./ArtifactItem.vue?vue&type=script&lang=js&"
export * from "./ArtifactItem.vue?vue&type=script&lang=js&"
import style0 from "./ArtifactItem.vue?vue&type=style&index=0&id=e34fbd70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e34fbd70",
  null
  
)

export default component.exports